import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { CenarioDetail } from '../types'
import { cenariosRepository } from './cenariosRepository'

export const useCenario = makeUseFetchOne<CenarioDetail, string>({
  fetch: cenariosRepository.fetchOne
})
